import { render, staticRenderFns } from "./activity_detail.vue?vue&type=template&id=a4525370&scoped=true"
import script from "./activity_detail.vue?vue&type=script&lang=ts"
export * from "./activity_detail.vue?vue&type=script&lang=ts"
import style0 from "./activity_detail.vue?vue&type=style&index=0&id=a4525370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4525370",
  null
  
)

export default component.exports